import { useEffect, useState } from 'react';
import { notification } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Place from '../../assets/icons/Place';
import empty from '../../assets/images/subject_empty.svg';
import SchoolSubjectCard from '../../components/LearnSubjectCard/SchoolSubjectCard';
import Carousel from 'react-multi-carousel';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import Spinner from '../../components/Spinner/Spinner';
import { baseURL } from '../../utils/axios';
import ReactPixel from 'react-facebook-pixel';

const SingleSchool = () => {
  let sCart = JSON.parse(localStorage.getItem('cart'));

  useEffect(() => {
    ReactPixel.pageView(); // Track a page view event
  }, []);

  const { id } = useParams();
  const navigate = useNavigate();
  const [school, setSchool] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState(sCart || []);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      paritialVisibilityGutter: 60,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 60,
    },
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  useEffect(() => {
    scrollToTop();
    const getSchool = async () => {
      setLoading(true);
      const res = await fetch(`${baseURL}/schools/${id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer `,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSchool(data.data.school);
      }
      setLoading(false);
      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        navigate('/login');
      }
      setLoading(false);
    };
    getSchool();
  }, []);

  let provider = window.location.pathname.includes('tutor')
    ? 'topics'
    : 'subjects';

  return (
    <div>
      <Helmet>
        <title> {school?.name ? school?.name : ''} | PL by Edves</title>
      </Helmet>{' '}
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Header />
          <div className='single-subject'>
            <div
              className='single-subject__hero'
              style={{
                backgroundImage: `url(${
                  // school?.banner ? school?.banner : school?.logo
                  school?.id === 15
                    ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1687385584/WhatsApp_Image_2023-06-16_at_21.04.51_henk2u.jpg'
                    : school.id === 37
                    ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1694165719/cdap_wbx4wp.jpg'
                    : 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683854614/banner_zebnu9.png'
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom 10px',
                //backgroundSize: 'contain',
              }}
            >
              <div className='single-subject__hero__breadcrumbs'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                    fill='white'
                  />
                </svg>
                <p>
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.history.back()}
                  >
                    Home{' '}
                  </span>
                  | {school?.name}
                </p>
              </div>
            </div>
            <div className='single-subject__hero__info'>
              <div className='single-subject__hero__info__logo'>
                <img
                  src={
                    school?.id === 60
                      ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1697073558/1fb2011b-23b3-4143-bb69-ffe34a366dbf_phezew.jpg'
                      : school?.logo
                  }
                  alt=''
                />
              </div>

              <div className='single-subject__hero__info__details'>
                <h2>{school?.name}</h2>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <Place />{' '}
                  <p>{`${school?.country ? school?.country : 'Nigeria'}`}</p>
                </div>
                <p>{school?.bio}</p>
              </div>
            </div>

            <div className='dashboard-body'>
              <div
                className='recommended-section__title'
                style={{ marginBottom: '40px' }}
              >
                <h2 style={{ textTransform: 'capitalize' }}>
                  {provider} offered
                </h2>
                <p>
                  These are {provider} specific to your class being offered by{' '}
                  {school?.name}
                </p>
              </div>
              {school?.courses?.length === 0 && (
                <div className='single-empty'>
                  <img src={empty} alt='' />
                  <p>
                    School is currently undergoing onboarding, please check back
                    later
                  </p>
                </div>
              )}
              <Carousel
                responsive={responsive}
                showDots={true}
                itemClass={`carouselItem`}
              >
                {school?.courses === undefined ? (
                  <div></div>
                ) : (
                  school?.courses?.map((el, index) => (
                    <SchoolSubjectCard
                      key={el.id}
                      schoolHeader={
                        school?.id === 12
                          ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680096219/WhatsApp_Image_2023-03-29_at_13.50.08_hqqdcv.jpg'
                          : el.banner
                      }
                      index={index}
                      price={el.price}
                      id={el.id}
                      schoolId={id}
                      subject={el.name}
                      description={el.description || 'No description available'}
                      topic={el.title}
                      duration={el.duration}
                      lessonStyle={el.lesson_style}
                      lessonCount={el.topics_count}
                      studentCount={el.students_count}
                      maxStudents={el.max_students}
                      currency={el.currency.symbol}
                      subjectClass={el.subject_class.title}
                      school={school}
                      selectSchool={() => {
                        if (sCart?.some((item) => item.id === el.id)) {
                          notification['error']({
                            message: 'Item already exists in cart',
                          });
                        } else {
                          setCart([...cart, el]);
                          localStorage.setItem(
                            'cart',
                            JSON.stringify([...cart, { ...el, school }])
                          );
                        }
                      }}
                      page='dashboard'
                    />
                  ))
                )}
              </Carousel>
            </div>
          </div>
          <div className='texture-bg'>
            <div className='cta'>
              <div className='cta__left'>
                <h1>
                  Your academic subject weakness can become an area of strength
                </h1>
                <p>
                  Be the first to know when we go live, register on PL by Edves
                  and <br /> become academic stars
                </p>
              </div>
              <div className='cta__right'>
                <Button
                  className='secondary-button'
                  text='Be The First To Know'
                />
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
};

export default SingleSchool;
